// extracted by css-extract-rspack-plugin
export default {"wrapper":"nzu2o","container":"XeAFn"};